"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LAYOUT_TYPES = exports.FormField = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _Icon = require("../Icon/Icon");
var _constants = require("../utils/constants");
var _useDebouncedState2 = require("../utils/useDebouncedState");
var _useFocusWithin2 = require("../utils/_useFocusWithin");
var _useUniqueId = require("../utils/useUniqueId");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _ValidationOverlay = require("../Forms/_ValidationOverlay");
var _FormFieldDecorator = require("./_FormFieldDecorator");
var _FormField = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./FormField.css") : void 0);
var _excluded = ["tailContainerProps", "allowReadonlyRequired", "className", "controlContainerProps", "decorators", "disabled", "enableScreenReaderStatus", "headingProps", "helpText", "helpTextProps", "hideValidationMessage", "screenReaderOnlyLabel", "id", "inputDescribedby", "inputId", "label", "labelProps", "layout", "readOnly", "renderInput", "inputProps", "required", "screenReaderMessage", "shrinkWrap", "size", "validationMessage", "controlProps", "controlRef", "canTruncate", "noTruncationOnFocus", "type", "validationOverlayProps", "describeControl"],
  _excluded2 = ["className", "overrideControlClasses"],
  _excluded3 = ["className", "overrideControlContainerClasses"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty2(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-form-field';
var LAYOUT_TYPES = exports.LAYOUT_TYPES = ['horizontal', 'vertical'];
var HEADING_DECORATOR_TYPES = ['headingStart', 'headingEnd', 'label'];
var FormField = exports.FormField = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context, _context2, _context3, _global$document, _ariaDescribedby$map$, _ariaDescribedby$map$2;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(FormField, _props)) : _props;
  var tailContainerProps = props.tailContainerProps,
    allowReadonlyRequired = props.allowReadonlyRequired,
    className = props.className,
    controlContainerProps = props.controlContainerProps,
    decorators = props.decorators,
    disabled = props.disabled,
    enableScreenReaderStatus = props.enableScreenReaderStatus,
    headingProps = props.headingProps,
    helpText = props.helpText,
    helpTextProps = props.helpTextProps,
    hideValidationMessage = props.hideValidationMessage,
    screenReaderOnlyLabel = props.screenReaderOnlyLabel,
    id = props.id,
    inputDescribedby = props.inputDescribedby,
    inputId = props.inputId,
    label = props.label,
    labelProps = props.labelProps,
    layout = props.layout,
    readOnly = props.readOnly,
    renderInput = props.renderInput,
    inputProps = props.inputProps,
    required = props.required,
    screenReaderMessage = props.screenReaderMessage,
    shrinkWrap = props.shrinkWrap,
    size = props.size,
    validationMessage = props.validationMessage,
    controlProps = props.controlProps,
    controlRef = props.controlRef,
    canTruncate = props.canTruncate,
    noTruncationOnFocus = props.noTruncationOnFocus,
    type = props.type,
    validationOverlayProps = props.validationOverlayProps,
    describeControl = props.describeControl,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var formFieldRef = (0, _react.useRef)();
  var mergedRef = (0, _reactMergeRefs.default)([formFieldRef, ref]);
  var _useFocusWithin = (0, _useFocusWithin2.useFocusWithin)({
      targetElement: formFieldRef.current
    }),
    isFocused = _useFocusWithin.isFocused;
  var themeProviderContext = (0, _react.useContext)(_reactUiTheming.ThemeProviderContext);
  var _ref = themeProviderContext || {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'concur_default' : _ref$theme;
  var classnames = _bind.default.bind(_FormField.default);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showValidation = _useState2[0],
    setShowValidation = _useState2[1];
  var isiOS = theme.indexOf('_ios') >= 0;
  var isAndroid = theme.indexOf('_android') >= 0;
  var isMobileTheme = isiOS || isAndroid;
  var componentId = (0, _useUniqueId.useUniqueId)();
  if (id) componentId = id;
  var helpTextId = (0, _useUniqueId.useUniqueId)();
  if (helpTextProps !== null && helpTextProps !== void 0 && helpTextProps.id) helpTextId = helpTextProps.id;
  var internalControlRef = (0, _react.useRef)();
  var isInfoIcon = (0, _includes.default)(_constants.ALLOWED_INFO_ICONS).call(_constants.ALLOWED_INFO_ICONS, validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state);
  var classes = classnames(_constants.CSS_PREFIX, CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), size !== 'lg'), "".concat(CSS_BLOCK, "--disabled"), disabled), "".concat(CSS_BLOCK, "--read-only"), readOnly && !disabled), (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "--")).call(_context2, isInfoIcon ? 'info' : validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state), !!validationMessage), "".concat(CSS_BLOCK, "--shrink-wrap"), shrinkWrap), (0, _concat.default)(_context3 = "".concat(CSS_BLOCK, "--")).call(_context3, layout), layout !== 'vertical'));
  var _ref2 = controlProps || {},
    controlClassName = _ref2.className,
    overrideControlClasses = _ref2.overrideControlClasses,
    otherControlProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var controlClasses = classnames(controlClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(_constants.CSS_PREFIX), !overrideControlClasses), "".concat(CSS_BLOCK, "__control"), !overrideControlClasses));
  var _ref3 = controlContainerProps || {},
    controlContainerClassName = _ref3.className,
    overrideControlContainerClasses = _ref3.overrideControlContainerClasses,
    otherControlContainerProps = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  var controlContainerClasses = classnames(controlContainerClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(_constants.CSS_PREFIX), !overrideControlContainerClasses), "".concat(CSS_BLOCK, "__control-container"), !overrideControlContainerClasses));
  var headingClasses = classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__heading"), headingProps === null || headingProps === void 0 ? void 0 : headingProps.className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__heading--android"), isAndroid));
  var labelClasses = classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__label"), labelProps === null || labelProps === void 0 ? void 0 : labelProps.className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__label--screen-reader-only"), isiOS || screenReaderOnlyLabel));
  var inputClasses = classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__input"), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__input--truncated"), type !== 'password' && canTruncate && (!isFocused || readOnly || disabled || !noTruncationOnFocus)), "".concat(CSS_BLOCK, "__canTruncate"), canTruncate));
  var helpClasses = classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__help"), helpTextProps === null || helpTextProps === void 0 ? void 0 : helpTextProps.className);
  var getHelpTextToRender = function getHelpTextToRender() {
    var textToRender = helpText;
    if (validationMessage && isMobileTheme) {
      textToRender = validationMessage.text;
    }
    return textToRender;
  };
  var helpTextToRender = getHelpTextToRender();
  var inputStartId = (0, _useUniqueId.useUniqueId)();
  var inputEndId = (0, _useUniqueId.useUniqueId)();
  var generateDescribedby = function generateDescribedby() {
    var totalIds = [];
    if (inputDescribedby) {
      if (Array.isArray(inputDescribedby)) {
        totalIds.push({
          name: 'consumerId',
          value: inputDescribedby.join(' ')
        });
      } else totalIds.push({
        name: 'consumerId',
        value: inputDescribedby
      });
    }
    if (decorators !== null && decorators !== void 0 && decorators.inputStart) {
      var inputStartArray = decorators.inputStart;
      if (!Array.isArray(inputStartArray)) {
        inputStartArray = [inputStartArray];
      }
      inputStartArray.forEach(function (decorator) {
        if (! /*#__PURE__*/_react.default.isValidElement(decorator)) {
          totalIds.push({
            name: 'inputStart',
            value: inputStartId
          });
        }
      });
    }
    if (decorators !== null && decorators !== void 0 && decorators.inputEnd) {
      var inputEndArray = decorators.inputEnd;
      if (!Array.isArray(inputEndArray)) {
        inputEndArray = [inputEndArray];
      }
      inputEndArray.forEach(function (decorator) {
        if (! /*#__PURE__*/_react.default.isValidElement(decorator)) {
          totalIds.push({
            name: 'inputEnd',
            value: inputEndId
          });
        }
      });
    }
    if (helpTextToRender) {
      totalIds.push({
        name: 'newHelpTextId',
        value: helpTextId
      });
    }
    return totalIds;
  };
  var doDecoratorsExist = function doDecoratorsExist(position) {
    return _react.default.Children.count(decorators === null || decorators === void 0 ? void 0 : decorators[position]) > 0;
  };
  var ariaDescribedby = generateDescribedby();
  var renderDecorators = function renderDecorators(position) {
    var _context4;
    if (!(decorators !== null && decorators !== void 0 && decorators[position])) return null;
    var isHeadingDecorator = (0, _includes.default)(HEADING_DECORATOR_TYPES).call(HEADING_DECORATOR_TYPES, position);
    if (isMobileTheme && isHeadingDecorator) {
      return null;
    }
    var parsedDecoratorId = ariaDescribedby === null || ariaDescribedby === void 0 ? void 0 : (0, _filter.default)(ariaDescribedby).call(ariaDescribedby, function (idObj) {
      return (idObj === null || idObj === void 0 ? void 0 : idObj.name) === position;
    });
    var isInputStart = position === 'inputStart';
    var isInput = position === 'inputStart' || position === 'inputEnd';
    return (0, _map.default)(_context4 = _react.default.Children).call(_context4, decorators === null || decorators === void 0 ? void 0 : decorators[position], function (decorator, index) {
      var _parsedDecoratorId$in, _decorator$type, _decorator$type2, _decorator$type3;
      return /*#__PURE__*/_react.default.createElement(_FormFieldDecorator.FormFieldDecorator, {
        className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__decorator"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__decorator--android"), isInputStart && isAndroid), "".concat(CSS_BLOCK, "__text-decorator"), isInput && ! /*#__PURE__*/_react.default.isValidElement(decorator)), "".concat(CSS_BLOCK, "__input-decorator"), isInput && /*#__PURE__*/_react.default.isValidElement(decorator)), "".concat(CSS_BLOCK, "__heading-decorator"), isHeadingDecorator)),
        decoratorId: parsedDecoratorId === null || parsedDecoratorId === void 0 || (_parsedDecoratorId$in = parsedDecoratorId[index]) === null || _parsedDecoratorId$in === void 0 ? void 0 : _parsedDecoratorId$in.value,
        disabled: disabled,
        position: position,
        readOnly: readOnly,
        showInReadOnlyMode: isInput && (! /*#__PURE__*/_react.default.isValidElement(decorator) || (decorator === null || decorator === void 0 || (_decorator$type = decorator.type) === null || _decorator$type === void 0 ? void 0 : _decorator$type.displayName) === 'Icon' || (decorator === null || decorator === void 0 || (_decorator$type2 = decorator.type) === null || _decorator$type2 === void 0 ? void 0 : _decorator$type2.displayName) === 'MultiComboBoxTokenizer' || (decorator === null || decorator === void 0 || (_decorator$type3 = decorator.type) === null || _decorator$type3 === void 0 ? void 0 : _decorator$type3.displayName) === 'Tokenizer'),
        size: size
      }, decorator);
    });
  };
  (0, _react.useEffect)(function () {
    var _internalControlRef$c;
    setShowValidation(!hideValidationMessage && !!validationMessage && isFocused && (internalControlRef === null || internalControlRef === void 0 || (_internalControlRef$c = internalControlRef.current) === null || _internalControlRef$c === void 0 ? void 0 : _internalControlRef$c.contains(document.activeElement)));
  }, [hideValidationMessage, isFocused, validationMessage, (_global$document = global.document) === null || _global$document === void 0 ? void 0 : _global$document.activeElement]);
  var anyTailContent = !!helpTextToRender || doDecoratorsExist('tailStart') || doDecoratorsExist('tailEnd');

  // We debounce the screenReaderMessage because updating it rapidly leads to repeated
  // announcements. With debouncing we can reasonably skip announcing a stale screenReaderMessage
  var _useDebouncedState = (0, _useDebouncedState2.useDebouncedState)(screenReaderMessage),
    debouncedMessage = _useDebouncedState.debouncedState,
    waiting = _useDebouncedState.waiting;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classes,
    id: componentId,
    ref: mergedRef
  }), enableScreenReaderStatus && /*#__PURE__*/_react.default.createElement("div", {
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true",
    className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "--screen-reader-only"))
  }, !waiting && debouncedMessage), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, headingProps, {
    className: headingClasses
  }), validationMessage && /*#__PURE__*/_react.default.createElement(_FormFieldDecorator.FormFieldDecorator, {
    position: "headingStart",
    size: size
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    iconName: isInfoIcon ? validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state : "messaging-".concat(validationMessage.state),
    className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__icon"), "".concat(CSS_BLOCK, "__decorator"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__info-icon"), isInfoIcon))
  })), renderDecorators('headingStart'), /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({}, labelProps, {
    className: labelClasses,
    htmlFor: inputId
  }), label), required && !disabled && (!readOnly || allowReadonlyRequired) && /*#__PURE__*/_react.default.createElement(_FormFieldDecorator.FormFieldDecorator, {
    className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__required"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__required--screen-reader-only"), isiOS)),
    position: "label",
    size: size
  }, "*"), renderDecorators('label'), doDecoratorsExist('headingEnd') && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__spacer"))
  }), renderDecorators('headingEnd'))), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherControlContainerProps, {
    className: controlContainerClasses
  }), /*#__PURE__*/_react.default.createElement(_ValidationOverlay.ValidationOverlay, (0, _extends2.default)({}, validationOverlayProps, {
    show: showValidation,
    validationMessage: _objectSpread(_objectSpread({}, validationMessage), {}, {
      state: isInfoIcon ? 'info' : validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state
    }),
    liveRegionClassName: classnames("".concat(CSS_BLOCK, "__live-region")),
    targetClassName: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__overlay"), validationOverlayProps === null || validationOverlayProps === void 0 ? void 0 : validationOverlayProps.targetClassName)
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherControlProps, {
    className: controlClasses,
    ref: (0, _reactMergeRefs.default)([controlRef, internalControlRef])
    // for select fields, we want the aria-describedby to be
    // on the control (role="combobox") and not the input
  }, describeControl ? {
    'aria-describedby': ((_ariaDescribedby$map$ = (0, _map.default)(ariaDescribedby).call(ariaDescribedby, function (element) {
      return element.value;
    }).join(' ')) === null || _ariaDescribedby$map$ === void 0 ? void 0 : (0, _trim.default)(_ariaDescribedby$map$).call(_ariaDescribedby$map$)) || undefined
  } : {}), renderDecorators('inputStart'), renderInput(_objectSpread(_objectSpread({}, inputProps), {}, {
    isFocused: isFocused,
    inputClassName: inputClasses,
    theme: theme
  }, !describeControl ? {
    'aria-describedby': ((_ariaDescribedby$map$2 = (0, _map.default)(ariaDescribedby).call(ariaDescribedby, function (element) {
      return element.value;
    }).join(' ')) === null || _ariaDescribedby$map$2 === void 0 ? void 0 : (0, _trim.default)(_ariaDescribedby$map$2).call(_ariaDescribedby$map$2)) || undefined
  } : {})), renderDecorators('inputEnd')), renderDecorators('afterInput'))), anyTailContent && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, tailContainerProps, {
    className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__tail-container"), tailContainerProps === null || tailContainerProps === void 0 ? void 0 : tailContainerProps.className)
  }), renderDecorators('tailStart'), helpTextToRender && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, helpTextProps, {
    className: helpClasses,
    id: helpTextId
  }), helpTextToRender), doDecoratorsExist('tailEnd') && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__spacer"))
  }), renderDecorators('tailEnd')))));
});
FormField.displayName = 'FormField';
FormField.propTypes = {
  /** @ignore The `id` attribute for the `<input>` element. */
  inputId: _propTypes.default.string.isRequired,
  /** Text to display inside of the `<label>` element. */
  label: _propTypes.default.node.isRequired,
  /** @ignore Render prop to return the node to render for the input control */
  renderInput: _propTypes.default.func.isRequired,
  /** Set to **true** to allow `readOnly` and `required` styles simultaneously. */
  allowReadonlyRequired: _propTypes.default.bool,
  /** Custom classes to be added to the outermost `<div>` tag. */
  className: _propTypes.default.string,
  /** Decorators provide add-on functionality to the input field and can be placed
   * in multiple locations.
   *
   * - `headingStart` (node or array of nodes): Positioned at the start of the heading area.
   * - `headingEnd` (node or array of nodes): Positioned at the end of the heading area.
   * - `inputStart` (node or array of nodes): Positioned at the start of the input.
   * - `inputEnd` (node or array of nodes): Positioned at the end of the input.
   * - `label` (node or array of nodes): Positioned at the end of the label.
   * - `tailStart` (node or array of nodes): Positioned after the input, before `helpText`.
   * - `tailEnd` (node or array of nodes): Positioned after the input, after `helpText`.
   */
  decorators: _propTypes.default.shape({
    headingStart: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),
    headingEnd: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),
    inputStart: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),
    inputEnd: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),
    label: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),
    tailStart: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),
    tailEnd: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)])
  }),
  /** Set to **true** to disable the input field. */
  disabled: _propTypes.default.bool,
  /** Set to **true** to enable announcing the `screenReaderMessage`. */
  enableScreenReaderStatus: _propTypes.default.bool,
  /** @ignore set by InputField and SelectField. */
  canTruncate: _propTypes.default.bool,
  /** @ignore set by InputField */
  noTruncationOnFocus: _propTypes.default.bool,
  /** @ignore set by SelectField. */
  describeControl: _propTypes.default.bool,
  /** Additional props to spread to the heading `<div>` element. */
  headingProps: _propTypes.default.object,
  /** Additional descriptive text for the input field. */
  helpText: _propTypes.default.node,
  /** Additional props to spread to the help text `<div>` element. */
  helpTextProps: _propTypes.default.object,
  /** @ignore set by consuming components when validation messages are displayed in overlays */
  hideValidationMessage: _propTypes.default.bool,
  /** Set to `true` to visually hide the `<label>`. */
  screenReaderOnlyLabel: _propTypes.default.bool,
  /** The `id` attribute for the component. */
  id: _propTypes.default.string,
  /** Additional `aria-describedby` `id`/s to be passed into the `<input>` element.  */
  inputDescribedby: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  /** Additional props to spread to the `<label>` element. */
  labelProps: _propTypes.default.object,
  /** Set to toggle the layout of the heading, control and additional help text.
   * Options are `'vertical'` (default) or `'horizontal'`. */
  layout: _propTypes.default.oneOf(LAYOUT_TYPES),
  /** Set to **true** to mark the input field as read-only. */
  readOnly: _propTypes.default.bool,
  /** Set to **true** to mark the input as a required field. */
  required: _propTypes.default.bool,
  /** Set to **true** to remove the bottom margin. */
  shrinkWrap: _propTypes.default.bool,
  /** A visually hidden, screen-reader only status message.  */
  screenReaderMessage: _propTypes.default.string,
  /** Size of the component. Options are `'lg'` and `'md'`. */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** Additional props spread to the `<div>` element which contains
   * `decorators.tailStart`, `hepText`, and `decorators.tailEnd`. */
  tailContainerProps: _propTypes.default.object,
  /** @ignore set by InputField. */
  type: _propTypes.default.string,
  /** An object identifying a validation message.
   * The object will include properties for `state` and `text`;
   * _e.g._, `{ state: 'warning', text: 'This is your last warning' }`.
   *
   * The options for `state` are 'error' and 'warning'.
   *
   * `text` is the message shown in the validation tooltip; as with all text,
   * it must be localized. */
  validationMessage: _propTypes.default.shape({
    state: _propTypes.default.oneOf(_constants.FORM_CONTROL_VALIDATION_STATES).isRequired,
    text: _propTypes.default.string.isRequired
  }),
  /** Additional props to be sent to the control `<div>`  */
  controlProps: _propTypes.default.object,
  /** Additional props to be sent to the control wrapper `<div>`  */
  controlContainerProps: _propTypes.default.object,
  /** Attach a ref to the control `<div>` element. */
  controlRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** @ignore - for internal use only */
  validationOverlayProps: _propTypes.default.object,
  /** @ignore - for internal use only, set by toolbar. */
  inputProps: _propTypes.default.object
};
FormField.defaultProps = {
  size: 'lg',
  layout: 'vertical',
  decorators: {}
};
var _default = exports.default = FormField;